import React, { useState, useEffect } from "react";
import { Button, Card } from "react-bootstrap";
import { Clock } from "react-bootstrap-icons";
import ActivityFormModal from "../../Modals/ActivityFormModal";
import { FaTrash, FaPen } from "react-icons/fa6";
import Swal from 'sweetalert2';
import { deleteActivityDate } from "../../../utils/Data/Activities";

const ActivityList = ({ selectedDate, activities, isAdmin }) => {
  const [showEditModal, setShowEditModal] = useState(false);
  const [formatedSelectedDate, setFormatedSelectedDate] = useState("");
  const [activityIdToEdit, setActivityIdToEdit] = useState(null);
  const [sortedActivities, setSortedActivities] = useState();

  useEffect(() => {
    const sortedActivities = activities.sort((a, b) => {
      return a.hora.localeCompare(b.hora);
    });
    setSortedActivities(sortedActivities);
  }, [activities]);

  const handleShowEditModal = (activity) => {
    setActivityIdToEdit(activity.id);
    setShowEditModal(true);
  };

  const handleCloseEditModal = () => setShowEditModal(false);

  const handleDelete = async (activity) => {
    Swal.fire({
      title: "¿Desea borrar la fecha de esta actividad?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, borrar",
      cancelButtonText: "Cancelar"
    }).then(async (result) => {
      if (result.isConfirmed) {
        await deleteActivityDate(activity, selectedDate);
        Swal.fire({
          title: "¡Fecha eliminada!",
          icon: "success"
        });
      }
    });
  }

  useEffect(() => {
    const [año, mes, día] = selectedDate.split("-");
    const fechaFormateada = `${día}/${mes}/${año}`;
    setFormatedSelectedDate(fechaFormateada);
  }, [selectedDate]);

  return (
    <div>
      <h4 className="mt-3 mb-3">Actividades para el día {formatedSelectedDate}</h4>
      {activities.length === 0 ? (
        <p>No hay actividades para este día.</p>
      ) : (
        <div className="d-flex flex-column gap-2">
          {(sortedActivities ? sortedActivities : activities).map((activity, index) => (
            <Card key={index} className="p-2 shadow-sm" style={{ borderLeft: "5px solid #1C79BD" }}>
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center gap-2">
                  <Clock /> <span>{activity.hora || "Hora no disponible"}</span>
                  <h6 className="m-0 ms-2">{activity.name}</h6>
                  <p>{activity.isSingleClass}</p>
                </div>

                {isAdmin ? (
                  <div className="d-flex align-items-center gap-2">
                    <Button variant="warning" size="sm" onClick={() => handleShowEditModal(activity)}>
                      <FaPen color="#ffffff" size="1rem" />
                    </Button>
                    <Button variant="danger" size="sm" onClick={() => handleDelete(activity)} disabled={activity.isSingleClass}>
                      <FaTrash />
                    </Button>
                  </div>
                ) : null}
              </div>
            </Card>
          ))}
        </div>
      )}

      <ActivityFormModal showModal={showEditModal} handleCloseModal={handleCloseEditModal} activityIdToEdit={activityIdToEdit} edit={true} />
    </div>
  );
};

export default ActivityList;